/**
 * Dungeon entry words (E4.6.S3 slice 2d, AD-704) — the toast lines for the
 * private `dungeonResult`, beside `shrineTravel.ts`'s for `travelResult`. The
 * reasons are the server's typed ones (dungeon-entry.ts); nothing is inferred.
 */

import type { DungeonResultPayload, DungeonRunOutcomeWire } from '@great-cloud/shared/client';

type DungeonDenied = Extract<DungeonResultPayload, { ok: false }>['denied'];

/** The toast line for a `dungeonResult` refusal (the typed reason, in words). */
export function describeDungeonDenial(denied: DungeonDenied): string {
  switch (denied) {
    case 'notNearEntrance':
      return 'Stand at the entrance to go in.';
    case 'inCombat':
      return 'The way down will not open in the middle of a fight.';
    case 'downed':
      return 'You cannot go in while down.';
    case 'alreadyInside':
      return 'You are already inside.';
    case 'tooSoon':
      return 'The entrance is still settling — try again in a moment.';
    case 'notInside':
      return 'You are not inside a dungeon.';
    case 'unavailable':
      return 'The way down will not open right now.';
    default:
      return 'There is no way in here.';
  }
}

/** The toast line for leaving, by how the run ended (absent = walked out). */
export function describeDungeonExit(outcome: DungeonRunOutcomeWire | undefined): string {
  switch (outcome) {
    case 'cleared':
      return 'The dungeon is cleared — you climb back out.';
    case 'wiped':
      return 'The dungeon throws you back out.';
    case 'expired':
      return 'The dungeon closes around you and lets you go.';
    case 'abandoned':
      return 'The dungeon closes — you are back outside.';
    default:
      return 'You climb back out.';
  }
}
